import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoNoConfig } from './presets/contact-axo-no.config';
import { globalNo } from './presets/global-no.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationAxoNoConfig } from './presets/organisation-axo-no.config';
import { serviceVwoUscoreConfig } from './presets/service-vwo-uscore.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';

export const global: GlobalConfig = {
  brand: 'uscore.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'uscore.no',
  name: 'uScore',
  theme: {
    name: 'uscore-light',
    brand: 'uscore',
  },
  path: {
    loansApply: '/soknad/lan',
    mypage: '/mine-tilbud',
  },
  ...organisationAxoNoConfig,
  ...contactAxoNoConfig,
  services: {
    cms: {
      accessToken: {
        production:
          'ac_23202bd59b8279c34822d8850585d44042ad35f204f2d1e78af6fee1789489dd',
        preview:
          'ac_212bfc96aae87be16728f7188d158b01fa911f66f7678be360041a02b09b8a23',
      },
    },
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '655392f86f1096327e38eeb6',
    },
    gtm: 'GTM-MMJ8P92Z',
    ga: 'G-598Y2XNJF6',
    gtmScriptStrategy: 'lazyOnload',
    usercentrics: {
      settingsId: 'NqAgIJI085tXD5',
      crossDomainBridgeScriptStrategy: 'lazyOnload',
      autoBlockerScriptStrategy: 'lazyOnload',
      usercentricsScriptStrategy: 'lazyOnload',
    },
    ...serviceVwoUscoreConfig,
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: false, ...myPageOffersConfig },
};
